<div class="overflow-page-container iframe-teaser">
  <div class="full-width">
		<iframe #iframe [src]="srcUrl" title="teaser"></iframe>
  </div>

</div>
